module.exports = __webpack_public_path__ + "img/MundZuVollGenommen.85522978.jpg";